import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "w100",
  style: {"height":"90vh"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "w100" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: ""
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "centered fs18 fw600 mt20" }, "アドレス帳から埋める", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, "アドレス帳から選択した送信先に複数まとめて送信ができます。", -1)
const _hoisted_8 = { class: "fw600" }
const _hoisted_9 = {
  key: 0,
  class: "ofs noscroll",
  style: {"height":"400px"}
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w100 rad20 pad20 llgreyBg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "centered fs18 fw600 mt20" }, "調整情報を設定")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "w80 mb20"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "fs14 fw600" }, "このイベント情報", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "fs14 fw600" }, "全体のタイトルとして表示されます。", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { class: "w100 mt20" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "所要時間", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { class: "w100 rad20 pad20 llgreyBg" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "centered fs18 fw600 mt20" }, "日程決定者・AI設定", -1)
const _hoisted_24 = { class: "mt20" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: `use_ai_fix_`,
  class: "fs13"
}, "AIが日程を確定する", -1)
const _hoisted_26 = {
  key: 0,
  class: "w100 pad10"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "fs12 fw600" }, "確定するためのAIへのプロンプト", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = { class: "mt20" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "orange fw600 fs12"
}
const _hoisted_32 = {
  key: 0,
  class: "mt20"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "grey fs12" }, " 決定者が指定した日程を最終的に承認する人を指定できます。設定しない場合は、日程決定者がそのまま確定します。 承認者を指定すると、承認者が場所を指定できます。 ", -1)
const _hoisted_34 = { key: 4 }
const _hoisted_35 = { class: "w100 rad20 pad20 llgreyBg" }
const _hoisted_36 = { class: "fl mt20 fs16 fw600" }
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = ["src"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs11",
  style: {"margin-top":"-5px"}
}, [
  /*#__PURE__*/_createTextVNode("フォーム内容"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("を閉じる")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = { class: "w100" }
const _hoisted_44 = { class: "fl mr6 mb5" }
const _hoisted_45 = { class: "fl" }
const _hoisted_46 = { class: "fs14 mt4" }
const _hoisted_47 = { class: "fl mb0 fw600" }
const _hoisted_48 = {
  key: 0,
  class: "fl fs11 fw600"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = { class: "fs11" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = { class: "fl mt30 fs16 fw600" }
const _hoisted_54 = ["src"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddressBookContent = _resolveComponent("AddressBookContent")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_MeetingTimeContent = _resolveComponent("MeetingTimeContent")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_AnsweredFormTable = _resolveComponent("AnsweredFormTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.viewType == `parg`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        _ctx.selectedTabName == 'appoInfo' ? 'selected fw600' : ''
                    }`),
              style: {
                        width: `33%`,
                    },
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCategoryTab('appoInfo')))
            }, " 調整情報 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        _ctx.selectedTabName == `addressbook` ? 'selected fw600' : ''
                    }`),
              style: {
                        width: `33%`,
                    },
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategoryTab('addressbook')))
            }, " アドレス帳 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        _ctx.selectedTabName == `fixer` ? 'selected fw600' : ''
                    }`),
              style: {
                        width: `33%`,
                        fontSize: `13px`,
                    },
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectCategoryTab('fixer')))
            }, " 日程決定者・AI設定 ", 2)
          ]),
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    ([`addressbook`].includes(_ctx.rcm.viewType))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.addressbookTypeText()), 1),
          (_ctx.rm.userInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_AddressBookContent, {
                  style: `margin-top:20px;padding:20px;`,
                  class: _normalizeClass(`lskyblueBg`),
                  members: [],
                  currentMember: _ctx.currentMember,
                  editOrNewForm: _ctx.editOrNewForm,
                  showEditButton: false,
                  showNewButton: true,
                  onAddAttendee: _ctx.addAttendee,
                  onSelectContactListGroup: _ctx.selectContactListGroup
                }, null, 8, ["currentMember", "editOrNewForm", "onAddAttendee", "onSelectContactListGroup"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : ([`appoInfo`].includes(_ctx.rcm.viewType))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", null, [
              (_ctx.rcm.parg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _hoisted_14,
                    _createVNode(_component_MdTextfieldTag, {
                      name: "タイトル",
                      style: {"height":"56px","min-width":"100%"},
                      fieldStyle: "min-width:100%;",
                      class: "fl fs14 mb5",
                      value: _ctx.rcm.parg.title,
                      onInputValue: _ctx.inputPargTitle
                    }, null, 8, ["value", "onInputValue"]),
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _hoisted_18,
                      _createVNode(_component_MeetingTimeContent, {
                        from: `room_settings`,
                        appo: _ctx.rcm.room.current_appointment,
                        onUpdateAppo: _ctx.updateAppo
                      }, null, 8, ["appo", "onUpdateAppo"])
                    ]),
                    _hoisted_19
                  ]))
                : _createCommentVNode("", true),
              _hoisted_20
            ])
          ]))
        : ([`fixer`].includes(_ctx.rcm.viewType))
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_CheckboxTag, {
                    value: ``,
                    name: `use_ai_fix`,
                    checked: _ctx.rcm.parg?.use_ai_fix,
                    prefix: `use_ai_fix`,
                    onClickCheckbox: _ctx.clickUseAiFix,
                    style: {"margin-left":"1px","margin-right":"7px"}
                  }, null, 8, ["checked", "onClickCheckbox"]),
                  _hoisted_25,
                  (_ctx.rcm.parg?.use_ai_fix)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode(_component_TextareaTag, {
                          placeholder: "当日よろしくお願いいたします。",
                          style: {"height":"120px"},
                          class: "fs14 roundForm mw100",
                          value: _ctx.rcm.parg?.ai_fix_message,
                          onInputValue: _ctx.inputAiFixMessage
                        }, null, 8, ["value", "onInputValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_28
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (_ctx.rcm.fixers.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_UserIcon, {
                          member: _ctx.rcm.fixers[0],
                          width: 38,
                          canEdit: false,
                          updateSelf: false,
                          showTooltip: false
                        }, null, 8, ["member"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "w100 pad10 circle_button blueAround rad8 mt20 centered fw600",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickFixer && _ctx.clickFixer(...args)))
                  }, " 日程決定者を指定する "),
                  (_ctx.rcm.parg?.use_ai_fix)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, " AIが確定した場合は、決定者は確定を行いません。 "))
                    : _createCommentVNode("", true)
                ]),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", {
                        class: "w100 pad10 circle_button blueAround rad8 mt20 centered fw600",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickApproval && _ctx.clickApproval(...args)))
                      }, " 日程承認者を指定する "),
                      _hoisted_33
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_ctx.rcm.viewType == `userInfo` && _ctx.rcm.currentSendMem)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/user_black.png`),
                      width: "24",
                      height: "26",
                      style: {"margin-top":"-3px"}
                    }, null, 8, _hoisted_37),
                    _createTextVNode(" 基本情報 "),
                    _hoisted_38
                  ]),
                  _createElementVNode("div", {
                    class: "fr centered pointer",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
                      width: "40",
                      height: "40",
                      class: ""
                    }, null, 8, _hoisted_39),
                    _hoisted_40,
                    _hoisted_41
                  ]),
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_UserIcon, {
                        member: _ctx.rcm.currentSendMem,
                        width: 38,
                        canEdit: false,
                        updateSelf: false,
                        showTooltip: false
                      }, null, 8, ["member"])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.rcm.currentSendMem.name), 1),
                        (_ctx.Util.isPresent(_ctx.rcm.currentSendMem.company_name))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, " (" + _toDisplayString(_ctx.rcm.currentSendMem.company_name) + ") ", 1))
                          : _createCommentVNode("", true),
                        _hoisted_49
                      ]),
                      _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.rcm.currentSendMem.email), 1)
                    ]),
                    _hoisted_51
                  ]),
                  _hoisted_52,
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
                      width: "20",
                      height: "20",
                      style: {"margin-top":"-3px"}
                    }, null, 8, _hoisted_54),
                    _createTextVNode(" フォーム内容 ")
                  ]),
                  _hoisted_55,
                  _createVNode(_component_AnsweredFormTable, {
                    results: _ctx.rcm.currentSendMem.answer_results,
                    room: null,
                    canEdit: false,
                    class: "mt20"
                  }, null, 8, ["results"]),
                  _hoisted_56
                ])
              ]))
            : _createCommentVNode("", true)
  ]))
}